import { gql } from "@apollo/client";

export const ADD_PRODUCT_RANGE = gql`
  mutation AddProductRange($data: ProductRangeDataInput) {
    addProductRange(data: $data) {
      id
      code
      label
    }
  }
`;

export const UPDATE_PRODUCT_RANGE = gql`
  mutation UpdateProductRange(
    $data: ProductRangeDataInput
    $where: ProductRangeWhereInput
  ) {
    updateProductRange(data: $data, where: $where) {
      id
      code
      label
    }
  }
`;

export const DELETE_PRODUCT_RANGE = gql`
  mutation DeleteProductRange($where: ProductRangeWhereInput) {
    deleteProductRange(where: $where) {
      id
    }
  }
`;

export const ADD_ADVISOR_PRODUCT_SELLER_CODE = gql`
  mutation AddAdvisorProductSellerCode(
    $data: AdvisorProductSellerCodeDataInput
  ) {
    addAdvisorProductSellerCode(data: $data) {
      id
      sellerCode
      hasApiPassword
    }
  }
`;

export const UPDATE_ADVISOR_PRODUCT_SELLER_CODE = gql`
  mutation UpdateAdvisorProductSellerCode(
    $data: AdvisorProductSellerCodeDataInput
    $where: AdvisorProductSellerCodeWhereInput
  ) {
    updateAdvisorProductSellerCode(data: $data, where: $where) {
      id
      sellerCode
      hasApiPassword
    }
  }
`;

export const ASSIGN_PROJECT_ADVISOR_CODE = gql`
  mutation AssignProjectAdvisorCode(
    $where: ProjectWhereInput
    $processId: ID!
    $code: String!
  ) {
    assignProjectAdvisorCode(where: $where, processId: $processId, code: $code)
  }
`;

export const DELETE_ADVISOR_PRODUCT_SELLER_CODE = gql`
  mutation DeleteAdvisorProductSellerCode(
    $where: AdvisorProductSellerCodeWhereInput
  ) {
    deleteAdvisorProductSellerCode(where: $where) {
      id
    }
  }
`;

const productRangeAdvisorCodesMutations = {
  ADD_PRODUCT_RANGE,
  UPDATE_PRODUCT_RANGE,
  DELETE_PRODUCT_RANGE,
  ADD_ADVISOR_PRODUCT_SELLER_CODE,
  UPDATE_ADVISOR_PRODUCT_SELLER_CODE,
  DELETE_ADVISOR_PRODUCT_SELLER_CODE,
  ASSIGN_PROJECT_ADVISOR_CODE,
};

export default productRangeAdvisorCodesMutations;
